import { ActionIcon, Tooltip } from "@mantine/core";
import { IconEye } from "@tabler/icons-react";

type InterestViewProfileIconButtonProps = {
  onClick: () => void;
  size?: "sm" | "md" | "lg";
};

export default function InterestViewProfileIconButton({
  onClick,
  size = "lg",
}: InterestViewProfileIconButtonProps) {
  return (
    <Tooltip label="View profile">
      <ActionIcon
        variant="light"
        color="primary"
        size={size}
        radius="md"
        aria-label="View profile"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onClick();
        }}
      >
        <IconEye size={18} />
      </ActionIcon>
    </Tooltip>
  );
}
